export const blue = "#55CDFC";  // trans flag color
export const lightpink = "#F7A8B8"; // trans flag color
export const pink = "#e897a7";
export const darkpink = "#de8395";
export const purple = "#80b";
export const lightpurple = "#c44af0";